"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.enhanceDataWithAnomalyDataFromColumns = exports.getDataItems = exports.getDataItemsAndMetaData = exports.fillGapsWithNaNs = exports.EMPTY_ArgumentDateTime = exports.normalizeArgumentNumeric = exports.timeSpanToEpoch = exports.dateTimeToEpoch = exports.ArgumentRestrictions = exports.ArgumentColumnType = exports.DataItem = void 0;
self.System2 = (_a = self.System2) !== null && _a !== void 0 ? _a : self.System;
function assertNever(x) {
    throw new Error('Unexpected object: ' + x);
}
exports.DataItem = Kusto.Charting.DataItem;
exports.ArgumentColumnType = Kusto.Charting.ArgumentColumnType;
exports.ArgumentRestrictions = Kusto.Charting.ArgumentRestrictions;
var DataChartsHelper = Kusto.Charting.DataChartsHelper;
var resolveColumnNamesFromData = function (dataSource, visualizationOptions) {
    var columnsToExclude = [];
    if (visualizationOptions.YColumns) {
        columnsToExclude.push.apply(columnsToExclude, visualizationOptions.YColumns);
    }
    if (visualizationOptions.XColumn) {
        columnsToExclude.push(visualizationOptions.XColumn);
    }
    var argumentColumnNames = DataChartsHelper.GetAllArgumentColumns(dataSource, new Bridge.ArrayEnumerable(columnsToExclude));
    // Add the first argument as series mapper
    var columnsMappedToSeries = [];
    if (visualizationOptions.Series && visualizationOptions.Series.length > 0) {
        columnsMappedToSeries = visualizationOptions.Series;
    }
    else {
        var firstNonNumericColumn = DataChartsHelper.GetFirstStringColumnName(dataSource, 1);
        if (firstNonNumericColumn && firstNonNumericColumn.length > 0) {
            columnsMappedToSeries = [firstNonNumericColumn];
        }
    }
    return {
        argumentColumnNames: argumentColumnNames,
        columnsMappedToSeries: new Bridge.ArrayEnumerable(columnsMappedToSeries),
    };
};
var toArgumentColumnType = function (t) {
    switch (t) {
        case 'decimal':
        case 'int':
        case 'long':
        case 'real':
            return exports.ArgumentColumnType.Numeric;
        case 'datetime':
            return exports.ArgumentColumnType.DateTime;
        case 'timespan':
            return exports.ArgumentColumnType.TimeSpan;
        case 'string':
            return exports.ArgumentColumnType.String;
        case 'dynamic':
            return exports.ArgumentColumnType.Object;
        default:
            return exports.ArgumentColumnType.None;
    }
};
var EPOCH_BASE_DATE = System2.DateTime.parseExact('70-01-01', 'yy-MM-dd', undefined);
function dateTimeToEpoch(time) {
    return System2.DateTime.subdd(time, EPOCH_BASE_DATE).getTotalMilliseconds();
}
exports.dateTimeToEpoch = dateTimeToEpoch;
function timeSpanToEpoch(time) {
    return System2.DateTime.subdd(time, new System2.TimeSpan()).getTotalMilliseconds();
}
exports.timeSpanToEpoch = timeSpanToEpoch;
function normalizeArgumentNumeric(type, val) {
    switch (type) {
        case exports.ArgumentColumnType.Numeric:
            return val;
        case exports.ArgumentColumnType.DateTime:
            return dateTimeToEpoch(val);
        case exports.ArgumentColumnType.TimeSpan:
            return timeSpanToEpoch(val);
        default:
            return Number.NaN;
    }
}
exports.normalizeArgumentNumeric = normalizeArgumentNumeric;
function toDataSource(schema, data) {
    var getSchema = function () {
        return new Bridge.ArrayEnumerable(schema.map(function (item) { return ({ Item1: item.ColumnName, Item2: toArgumentColumnType(item.ColumnType) }); }));
    };
    var getValue = function (row, col) {
        if (col < 0 || col >= schema.length || row < 0 || row >= data.length) {
            return null;
        }
        var columnType = schema[col].ColumnType;
        var rawValue = data[row][schema[col].ColumnName];
        if (columnType === 'datetime') {
            // Make sure that DateTime is kept in GMT !!
            var t = System2.DateTime.parseExact(rawValue, "yyyy'-'MM'-'dd'T'HH':'mm':'ss.FFFFFFFZ", null, !0, !0);
            // fix seconds frication issue
            // 1. bridge doesn't support more then 3 digit - TODO: Fix this in the future
            // 2. if less then 3 digit provided - it take it as less significant
            //    e.g. 0.1 -> 1 millisecond instead of 100 millisecond
            var len = rawValue === null || rawValue === void 0 ? void 0 : rawValue.length;
            if (len == 23) {
                // only 2 digit xxx.12Z - 12 milliseconds - should be 120;
                t = System2.DateTime.addMilliseconds(t, t.getMilliseconds() * 9);
            }
            else if (len == 22) {
                // only 1 digit xxx.4Z - 4 milliseconds - should be 400
                t = System2.DateTime.addMilliseconds(t, t.getMilliseconds() * 99);
            }
            return t;
        }
        else if (columnType === 'timespan') {
            return System2.TimeSpan.parse(rawValue);
        }
        return rawValue;
    };
    return {
        GetSchema: getSchema,
        Kusto$Charting$IChartingDataSource$GetSchema: getSchema,
        RowsCount: data.length,
        Kusto$Charting$IChartingDataSource$RowsCount: data.length,
        GetValue: getValue,
        Kusto$Charting$IChartingDataSource$GetValue: getValue,
    };
}
function toArray(ienumerable) {
    return Bridge.toArray(ienumerable);
}
// We expect System or System2 to exist (sometimes System is reserved for system2.js and we will use System2.
// having a global System2  has to be taken care of by hosting app by assigning System2 in a script tag or something similar).
var List = System2.Collections ? System2.Collections.Generic.List$1 : System2.Collections.Generic.List$1;
exports.EMPTY_ArgumentDateTime = new exports.DataItem().ArgumentDateTime;
function fillGapsWithNaNs(items, columnType) {
    var bridgifiedItems = new (List(exports.DataItem).$ctor1)(items);
    var bridgeResult = DataChartsHelper.FillGapsWithNaNs(bridgifiedItems, toArgumentColumnType(columnType));
    return toArray(bridgeResult);
}
exports.fillGapsWithNaNs = fillGapsWithNaNs;
function getDataItemsAndMetaData(columns, rows, visualizationOptions) {
    var dataSource = toDataSource(columns, rows);
    var series = visualizationOptions.Series ? new Bridge.ArrayEnumerable(visualizationOptions.Series) : undefined;
    var xColumn = visualizationOptions.XColumn || undefined;
    var yColumns = visualizationOptions.YColumns
        ? new Bridge.ArrayEnumerable(visualizationOptions.YColumns)
        : new Bridge.ArrayEnumerable([]);
    var data = { metaData: null };
    var getData = function (argumentColumnType, argumentRestrictions, seriesColumns) {
        var metaData = DataChartsHelper.GetMetaData(dataSource, argumentColumnType, argumentRestrictions, seriesColumns || series, xColumn, yColumns);
        if (metaData) {
            // UnusedIndexes is used for displaying extra columns in tooltip. It's a huge overhead and therefore disabling this feature.
            metaData.UnusedIndexes = new Bridge.ArrayEnumerable([]);
        }
        var items = metaData
            ? toArray(DataChartsHelper.GetData$1(dataSource, metaData, visualizationOptions.Accumulate))
            : [];
        var argumentType = metaData && metaData.ArgumentDataColumnIndex >= 0
            ? toArgumentColumnType(columns[metaData.ArgumentDataColumnIndex].ColumnType)
            : undefined;
        if (argumentType === exports.ArgumentColumnType.Object && metaData) {
            argumentType = DataChartsHelper.ResolveJsonArrayType(dataSource.GetValue(0, metaData.ArgumentDataColumnIndex));
        }
        return { items: items, argumentType: argumentType, metaData: metaData };
    };
    switch (visualizationOptions.Visualization) {
        case 'barchart':
        case 'columnchart':
            var _a = resolveColumnNamesFromData(dataSource, visualizationOptions), argumentColumnNames = _a.argumentColumnNames, columnsMappedToSeries = _a.columnsMappedToSeries;
            data = getData(exports.ArgumentColumnType.AllExceptGeospatial, exports.ArgumentRestrictions.MustHave | exports.ArgumentRestrictions.NotIncludedInSeries, columnsMappedToSeries);
            if (!data.items || data.items.length === 0) {
                data = getData(exports.ArgumentColumnType.StringOrDateTimeOrTimeSpan, exports.ArgumentRestrictions.MustHave | exports.ArgumentRestrictions.NotIncludedInSeries, columnsMappedToSeries);
            }
            break;
        case 'piechart':
            data =
                visualizationOptions.Kind === 'map'
                    ? getData(exports.ArgumentColumnType.Geospatial, exports.ArgumentRestrictions.GeospatialAsSeries)
                    : getData(exports.ArgumentColumnType.String, exports.ArgumentRestrictions.NotIncludedInSeries);
            break;
        case 'scatterchart':
            data =
                visualizationOptions.Kind === 'map'
                    ? getData(exports.ArgumentColumnType.Geospatial)
                    : getData(exports.ArgumentColumnType.NumericOrDateTimeOrTimeSpan);
            break;
        case 'stackedareachart':
        case 'areachart':
        case 'linechart':
        case 'timechart':
            var columnType = visualizationOptions.Visualization === 'timechart'
                ? exports.ArgumentColumnType.DateTimeOrTimeSpan
                : exports.ArgumentColumnType.NumericOrDateTimeOrTimeSpan;
            try {
                data = getData(columnType);
            }
            catch (error) { }
            if (data && data.items && data.items.length > 0) {
                break;
            }
            // if we got here we couldn't figure out how to draw the chart.
            // maybe the user formatted the numeric / datetime data  into a string? If the data is sorted we might be
            // able to chart it anyway by allowing strings to be x axis as well.
            try {
                data = getData(exports.ArgumentColumnType.StringOrDateTimeOrTimeSpan, exports.ArgumentRestrictions.NotIncludedInSeries);
            }
            catch (error) { }
            if (data && data.items && data.items.length > 0) {
                if (visualizationOptions.IsQuerySorted) {
                    break;
                }
                else {
                    throw new Error(visualizationOptions.Visualization + " requires the data to be either numeric or sorted. try using the order operator in your query.");
                }
            }
            break;
        case 'anomalychart':
            data = getData(exports.ArgumentColumnType.DateTimeOrTimeSpan);
            break;
        case 'ladderchart':
        case 'pivotchart':
        case 'table':
        case 'timeline':
        case 'timepivot':
        case 'card':
            throw new Error("visualization type " + visualizationOptions.Visualization + " is not yet supported");
        case null:
            throw new Error('visualization type cannot be null');
        default:
            assertNever(visualizationOptions.Visualization);
    }
    return data;
}
exports.getDataItemsAndMetaData = getDataItemsAndMetaData;
/**
 * @deprecated Since version 0.0.51. Will be deleted in version 1.0
 */
function getDataItems(columns, rows, visualizationOptions) {
    var items = getDataItemsAndMetaData(columns, rows, visualizationOptions).items;
    return items !== undefined ? items : null;
}
exports.getDataItems = getDataItems;
function enhanceDataWithAnomalyDataFromColumns(items, anomalyColumns) {
    var bridgifiedItems = new (List(exports.DataItem).$ctor1)(items);
    var map = {};
    var data = Kusto.Charting.AnomalyDataHelper2.EnchanceDataWithAnomalyDataFromColumns(bridgifiedItems, anomalyColumns, map);
    return toArray(data);
}
exports.enhanceDataWithAnomalyDataFromColumns = enhanceDataWithAnomalyDataFromColumns;
//# sourceMappingURL=main.js.map